import * as types from "../types/token"

export const setTokens = tokens => ({
  type: types.SET_TOKENS,
  tokens
})

export const deleteTokens = () => ({
  type: types.DELETE_TOKENS
})